import type { CrossJoinIntegraton } from '@atlassian/cross-join-nudges';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance';
import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys';

const EXPIRY_IN_7_DAYS = 60 * 60 * 24 * 7;
const EXPIRY_IN_30_DAYS = 60 * 60 * 24 * 30;

export const isFeatureVisited = async (integration: CrossJoinIntegraton): Promise<boolean> => {
	try {
		if (getFeatureVisited(integration)) {
			return true;
		}
		void snoozeFeatureFor7Days(integration);
		if (!getFeatureVisited(integration)) {
			return true;
		}
		return false;
	} catch (error: any) {
		return true;
	}
};

export const getFeatureVisitedCount = (integration: CrossJoinIntegraton): number => {
	const value = localStorage.getItem(getVisitedCountStorageKey(integration));
	return parseInt(value, 10) || 0;
};

export const increaseFeatureVisitedCount = (integration: CrossJoinIntegraton) => {
	const currentCount = getFeatureVisitedCount(integration);
	localStorage.setItem(getVisitedCountStorageKey(integration), currentCount + 1);
};

export const snoozeFeatureFor7Days = (integration: CrossJoinIntegraton) => {
	setFeatureVisited(integration, EXPIRY_IN_7_DAYS);
};

export const snoozeFeatureFor30Days = (integration: CrossJoinIntegraton) => {
	setFeatureVisited(integration, EXPIRY_IN_30_DAYS);
};

const setFeatureVisited = (integration: CrossJoinIntegraton, expire: number) => {
	localStorage.setItem(getVisitedStorageKey(integration), true, expire);
};

export const getFeatureVisited = (integration: CrossJoinIntegraton): boolean =>
	localStorage.getItemAsBoolean(getVisitedStorageKey(integration));

export const setUserOptedOut = (integration: CrossJoinIntegraton) => {
	localStorage.setItem(getOptOutStorageKey(integration), true);
};

export const isUserOptedOut = (integration: CrossJoinIntegraton) =>
	localStorage.getItemAsBoolean(getOptOutStorageKey(integration));

function getOptOutStorageKey(integration: CrossJoinIntegraton): string {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return localStorageKeys.CROSS_JOIN_NUDGES_V3_USER_OPT_OUT;
		case 'crossJoinNudgesConfluenceToJpd':
			return localStorageKeys.CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT;
		case 'crossJoinNudgesConfluenceToJpdMsr':
			return localStorageKeys.CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT;
		case 'crossJoinNudgesConfluenceToJiraMsr':
			return localStorageKeys.CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT;
		case 'crossJoinNudgesConfluenceToLoom':
			return localStorageKeys.CROSS_JOIN_NUDGES_LOOM_OPT_OUT;
		default: // error TS2366: Function lacks ending return statement and return type does not include 'undefined'.
			return '';
	}
}

function getVisitedStorageKey(integration: CrossJoinIntegraton): string {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return localStorageKeys.CROSS_JOIN_NUDGES_V3_VISITED_KEY;
		case 'crossJoinNudgesConfluenceToJpd':
			return localStorageKeys.CROSS_JOIN_NUDGES_JPD_VISITED_KEY;
		case 'crossJoinNudgesConfluenceToLoom':
			return localStorageKeys.CROSS_JOIN_NUDGES_LOOM_VISITED_KEY;
		default: // error TS2366: Function lacks ending return statement and return type does not include 'undefined'.
			return '';
	}
}

function getVisitedCountStorageKey(integration: CrossJoinIntegraton): string {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return localStorageKeys.CROSS_JOIN_NUDGES_V3_VISITED_COUNT;
		case 'crossJoinNudgesConfluenceToJpd':
			return localStorageKeys.CROSS_JOIN_NUDGES_JPD_VISITED_COUNT;
		case 'crossJoinNudgesConfluenceToJpdMsr':
			return localStorageKeys.CROSS_JOIN_NUDGES_MSR_VISITED_COUNT;
		case 'crossJoinNudgesConfluenceToJiraMsr':
			return localStorageKeys.CROSS_JOIN_NUDGES_MSR_VISITED_COUNT;
		case 'crossJoinNudgesConfluenceToLoom':
			return localStorageKeys.CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT;
		default: // error TS2366: Function lacks ending return statement and return type does not include 'undefined'.
			return '';
	}
}
